module.exports = __webpack_public_path__ + "img/p1-info@2x.114e1fd0.jpg";